import React, { useEffect, useState } from "react"
import { Card, Col, Modal } from "react-bootstrap"

import { useTranslation } from "react-i18next"

const ModalProvider = props => {
  // PROPERTIES
  const { t } = useTranslation("global")
  // METHODS

  // EVENTS

  return (
    <>

      <Modal
        show={true}
        onHide={props.toggle}
        size={props.modalSize ? props.modalSize : "lg"}
        className={props.cssClass + " modalRight"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Formulario representate laboral")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="my-4 ">
            <Card.Header className="text-start">

              <small className="text-uppercase">{t('Envie este formulario al representante laboral para completar la solicitud')}</small>
            </Card.Header>
            <Card.Body className="text-start">
              <label>URL</label>
              <br />
              <small className="text-muted mb-4">
                Utilice el siguiente enlace para completar la solicitud
              </small>
              <input
                type="text"
                className="form-control"
                value={
                  "https://dataworker.com.do/externaProviderLaborAccessRequest/" +
                  props.record?.id
                }
              />
            </Card.Body>
            <Card.Footer className="text-end">
              <button
                className="btn btn-primary"
                onClick={() => {
                  navigator.clipboard.writeText(
                    "https://dataworker.com.do/externaProviderLaborAccessRequest/" +
                    props.record?.id
                  )
                  alert("Enlace copiado al portapapeles")
                }}
              >
                Copiar enlace
              </button>
              <button
                className="btn btn-secondary ms-2"
                onClick={() => {
                  window.open(
                    "https://dataworker.com.do/externaProviderLaborAccessRequest/" +
                    props.record?.id
                  )
                }}
              >
                Ir al enlace
              </button>
            </Card.Footer>
          </Card>
        </Modal.Body>


      </Modal>
    </>
  )
}

export default ModalProvider
